import {StyledGeneratedContentSectionTitle} from '@/features/project/components/generated-content-section-title/style.ts'
import {FC, ReactNode} from 'react'

export const GeneratedContentSectionTitle: FC<{children: ReactNode}> = ({children}) => {
    return <StyledGeneratedContentSectionTitle>{children}</StyledGeneratedContentSectionTitle>
}

GeneratedContentSectionTitle.displayName = 'GeneratedContentSectionTitle'
